import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { XCircle, ArrowLeft } from 'lucide-react';

export default function EventCancelled() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6 text-center" data-testid="event-cancelled-page">
      <XCircle className="h-12 w-12 text-orange-400 mb-4" />
      <h1 className="font-display text-3xl text-foreground mb-2">Payment Cancelled</h1>
      <p className="text-muted-foreground mb-6 max-w-md">
        Your payment was cancelled and no registration was completed. You can try again or contact us if you need help.
      </p>
      <div className="flex gap-3 flex-wrap justify-center">
        <Button onClick={() => navigate('/register')} variant="outline" data-testid="event-cancelled-hub-btn">
          <ArrowLeft className="h-4 w-4 mr-2" /> Registration Hub
        </Button>
        <Button onClick={() => navigate(-1)} data-testid="event-cancelled-retry-btn">
          Try Again
        </Button>
      </div>
    </div>
  );
}
